export default __webpack_public_path__ + "static/media/cat-placeholder.70219175.svg";